const servicesData = [
    {
        id: "1",
        icon: require("../../assets/icons/AuditServices.svg").default,
        title: "Audit Services",
        details: "Comprehensive audit and assurance services ensuring compliance with international standards and regulatory requirements.",
        points: [
            "External Audits",
            "Internal Audits",
            "Compliance Reviews",
            "Risk Assessment",
        ]
    },
    {
        id: "2",
        icon: require("../../assets/icons/Tax.svg").default,
        title: "Tax Advisory",
        details: "Expert tax planning and compliance services to optimize your tax position while ensuring full regulatory compliance.",
        points: [
            // "VAT Registration",
            // "Corporate Tax", 
            "Tax Planning",
            "Tax Returns",
            "Direct Tax",
            "Indirect Tax",
            "Tax Agency Services",
        ]
    },
    {
        id: "3",
        icon: require("../../assets/icons/BusinessAdvisory.svg").default,
        title: "Business Advisory",
        details: "Strategic business consulting to help you make informed decisions and achieve sustainable growth.",
        points: [
            "Financial Planning",
            "Business Strategy",
            "Risk Management",
            "Performance Analysis",
        ]
    },
    {
        id: "4",
        icon: require("../../assets/icons/ForensicAccounting.svg").default,
        title: "Forensic Accounting",
        details: "Professional investigation services to detect fraud, resolve disputes, and provide litigation support.",
        points: [
            "Fraud Investigation",
            "Expert Testimony",
            "Dispute Resolution",
            "Asset Tracing",
        ]
    },
    {
        id: "5",
        icon: require("../../assets/icons/ICV.svg").default,
        title: "ICV Certificate",
        details: "In-Country Value certification services to help businesses maximize local content and comply with UAE regulations",
        points: [
            "ICV Assessment",
            "Certification Support",
            "Compliance Monitoring",
            "Documentation",
        ]
    },
    {
        id: "6",
        icon: require("../../assets/icons/LiquidationServices.svg").default,
        title: "Liquidation Services",
        details: "Professional liquidation and restructuring services to help businesses through complex transitions",
        points: [
            "Asset Valuation",
            "Debt Settlement",
            "Legal Compliance",
            "Stakeholder Management",
        ]
    },
]

export default servicesData;